enum HOME {
  HomeCta = "home-cta",
  HomeViewAll = "home-view-all",
  CampaignView = "campaign-view",
  CampaignClick = "campaign-click",
  CampaignPhone = "campaign-phone",
  JoinAffiliateView = "join-affiliate-view",
  JoinAffiliateClick = "join-affiliate-click",
  JoinAffiliateCopy = "join-affiliate-copy",
  SmallHeaderClick = "small-header-click",
  // TelegramGroupWhatsapp = 'telegram-group-whatsapp-click',
  // TelegramGroupView = 'telegram-group-view',
  LifeTimeClick = "life-time-click",
  LifeTimeView = "life-time-view",
  EnglishTtutorBanner = "english_tutor_banner",
}

enum PREMADE_PAPER {
  PremadePaperSearch = "premade-paper-search",
  PremadePaperLoadMore = "premade-paper-load-more",
  PremadePaperClick = "premade-paper-click",
  PremadePaperDownload = "premade-paper-download",
  PremadePaperLimitHit = "premade-paper-limit-hit",
  PremadePaperRegister = "premade-paper-register",
  PremadePaperView = "premade-paper-view",
  PremadeHighlightClick = "premade-highlight-click",
}

enum COURSE {
  CoursePurchase = "course-purchase",
  CourseBecomePremium = "course-become-premium",
  CoursePlayVideo = "course-play-video",
}

enum PURCHASE {
  PurchaseSuccess = "purchase-sucess",
}

enum PAPER {
  PaperAddOwnQuestionClick = "paper-add-own-question-click",
  PaperAddMoreQuestionCLick = "paper-add-more-question-click",
  PaperGeneratePdfClick = "paper-generate-pdf-click",
  PaperRearrangePositionClick = "paper-rearrange-position-click",
  PaperDeleteClick = "paper-delete-click",
  //
  PaperCreate = "paper-create",
  PaperGeneratePdf = "paper-generate-pdf",
}

enum QUESTION {
  QuestionEditClick = "question-edit-click",
  QuestionAdd = "question-add",
}

enum QUESTION_BANK {
  bankSearch = "bank-search",
  bankScrollMore = "bank-scroll-more",
}

enum QUESTION_EDITOR {
  EditorCreateQuestion = "editor-create-question",
  EditorUpdateQuestion = "editor-update-question",
}

enum USER {
  Signup = "signup",
  SignIn = "signin",
  FirstVisit = "first-visit",
  ReviewModalOpen = "review-modal-open",
  ReviewSubmit = "review-submit",
  CareerSubmit = "career-submit",
  bootcampClick = "ads-bootcamp-click",
}

enum SUBSCRIPTION {
  SubscriptionFreeClick = "subscription-free-click",
  SubscriptionOneMonthClick = "subscription-1-month-click",
  SubscriptionSixMonthClick = "subscription-6-month-click",
  SubscriptionShowAllQuestionClick = "subscription-show-all-question-click",
  SubscriptionSuccess = "subscription-success",
  SubscriptionWhatsapp = "subscription-whatsapp",
}

enum BLOG {
  BlogLoadMore = "blog-load-more",
  BlogSearch = "blog-search",
  BlogShare = "blog-share",
  BlogView = "blog-view",
  BlogBannerClick = "blog-banner-click",
}

enum TUTORIAL_VIDEO_PAPER {
  VideoPlay = "video-play",
  VideoEnd = "video-end",
  VideoError = "video-error",
  VideoBrowseClick = "video-browse-click",
}

enum ERROR {
  ErrorSignin = "error-signin",
  ErrorSignup = "error-signup",
  ErrorGeneratePdf = "error-generate-pdf",
  ErrorBankSearch = "error-bank-search",
  Error500 = "error-500",
  Error400 = "error-400",
  Error300 = "error-300",
}

enum ADSENSE {
  AdsenseRequest = "adsense-request",
  AdsenseFilled = "adsense-filled",
  AdsenseUnfilled = "adsense-unfilled",
}

enum LOAD_TIME {
  LoadTimeHome = "load-time-home",
  LoadTimePreCollections = "load-time-precollections",
  LoadTimePreCollection = "load-time-precollection",
  LoadTimeDownloadPdf = "load-time-download-pdf",
}

enum AUTOGRADE {
  AutoGrade_AddPaperClick = "autograde-add_paper_click",
  AutoGrade_ModalAddPaper = "autograde-modal_add_paper",
  AutoGrade_Register = "autograde-register",
  AutoGrade_AddPaper = "autograde-add_paper",
  AutoGrade_ViewPaper = "autograde-view_paper",
  AutoGrade_ModalAddAnswerSheet = "autograde-modal_add_answer_sheet",
  AutoGrade_ModalAddSchema = "autograde-modal_add_schema",
  AutoGrade_ModalPremium = "autograde-modal_premium",
  AutoGrade_ModalStart = "autograde-modal_start",
  AutoGrade_Start = "autograde-start",
  AutoGrade_Banner = "autograde-banner",
}

enum CAREER_PATH {
  CareerPath_view = "career_path-view",
  CareerPath_view_click = "career_path-view-click",
  CareerPath_submit = "career_path-submit",

  CareerPath_subject_click = "career_path-subject-click",
  CareerPath_interest_write = "career_path-interest-write",
  CareerPath_environment_click = "career_path-environment-click",
  
  CareerPath_unlock_more = "career_path-unclock-more",
  CareerPath_unlock_salary = "career_path-unclock-salary",
  CareerPath_full_access = "career_path-full_access",
}

export type MP_VALUE_TYPE =
  | HOME
  | USER
  | SUBSCRIPTION
  | PREMADE_PAPER
  | COURSE
  | PURCHASE
  | PAPER
  | QUESTION
  | QUESTION_EDITOR
  | QUESTION_BANK
  | BLOG
  | TUTORIAL_VIDEO_PAPER
  | ERROR
  | ADSENSE
  | LOAD_TIME
  | AUTOGRADE
  | CAREER_PATH;

export const MP_VALUE = {
  ...HOME,
  ...USER,
  ...SUBSCRIPTION,
  //
  ...PREMADE_PAPER,
  ...COURSE,
  ...PURCHASE,
  //
  ...PAPER,
  ...QUESTION,
  ...QUESTION_EDITOR,
  ...QUESTION_BANK,
  //
  ...BLOG,
  ...TUTORIAL_VIDEO_PAPER,
  ...ERROR,
  ...ADSENSE,
  ...LOAD_TIME,
  ...AUTOGRADE,
  ...CAREER_PATH,
};
